<template>
  <div class="spinner" :style="{ width: width + 'px', height: height + 'px' }">
    <div :style="{ 'border-width': size + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: ['width', 'height', 'size'],
};
</script>

<style scoped>
.spinner {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.spinner div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  border: 8px solid;
  border-radius: 50%;
  border-color: #4082f3 transparent transparent #4082f3;
  animation: spinner 0.6s infinite;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue